export const DEFAULT_DOCUMENT_INFO = {
  documentUrl: '',
  documentName: '',
  fileSize: 0,
  file: undefined
};
